import React, { useState } from "react";
import { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import {
  DeleteBatch,
  SubmitBatchResults,
  DeleteSample,
  SaveBatchEditHistory,
} from "../../services/BatchService";
import { NotificationManager } from "react-notifications";
import { BatchName, getFormattedDateTime } from "../../services/dateService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfirmationPopup from "../common/ConfirmationPopup";
import InformationPopup from "../common/InformationPopup";
import BatchCheckOutConfirmationPopup from "../common/BatchCheckOutConfirmationPopup";
import { formatDateTime } from "../../common-utilities/date-utility";
import {
  faCamera,
  faImage,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Modal from "../common/Modal";
import Webcam from "react-webcam";
import EditMicroOutBatchDialog from "./EditMicroOutBatchDialog";
import AddSamplesDialog from "./AddSamplesDialog";
import { IconButton } from "@mui/material";
import { isMobile } from "react-device-detect";
export default function MicroOutForm(props) {
  const { model, onSuccess, isFromVlp, users } = props;
  const { register, handleSubmit, control, reset, getValues } = useForm({
    defaultValues: model,
  });
  const [shouldSave, setShouldSave] = useState(false);
  const [sampleModals, setSampleModals] = useState({});
  const [compareModals, setCompareModals] = useState({});
  const [submissionModal, setSubmissionModal] = useState(null);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const [isDeleteSampleConfirmationOpen, setIsDeleteSampleConfirmationOpen] =
    useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [isHpcResultInfoOpen, setIsHpcResultInfoOpen] = useState(false);
  const [isCheckoutTimeOpen, setIsCheckoutTimeOpen] = useState(false);
  const [batchData, setBatchData] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [isAddSamplesDialogOpen, setIsAddSamplesDialogOpen] = useState(false);
  const [currentBatch, setCurrentBatch] = useState(null);
  const [deleteSampleLabelId, setDeleteSampleLabelId] = useState(0);
  const [outUser, setOutUser] = useState("");

  const { fields, update } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "samplesInBatch", // unique name for your Field Array
  });
  const hpcBatchResults = [
    "<2",
    null,
    "",
    "2",
    "4",
    "6",
    "8",
    "10",
    "12",
    "15",
    "17",
    "19",
    "21",
    "23",
    "26",
    "28",
    "30",
    "33",
    "35",
    "38",
    "40",
    "43",
    "45",
    "48",
    "51",
    "53",
    "56",
    "59",
    "62",
    "65",
    "68",
    "71",
    "74",
    "77",
    "80",
    "83",
    "86",
    "90",
    "93",
    "97",
    "100",
    "104",
    "108",
    "112",
    "116",
    "120",
    "124",
    "128",
    "132",
    "137",
    "141",
    "146",
    "151",
    "156",
    "161",
    "166",
    "171",
    "177",
    "183",
    "189",
    "195",
    "202",
    "209",
    "216",
    "223",
    "231",
    "239",
    "248",
    "257",
    "266",
    "276",
    "287",
    "299",
    "311",
    "324",
    "339",
    "355",
    "372",
    "392",
    "414",
    "440",
    "470",
    "507",
    "555",
    "623",
    "738",
    ">738",
  ];

  useEffect(() => {
    setLoggedInUser(JSON.parse(localStorage.getItem("loggedInUser")));
    let mappings = {};
    fields.map((item, i) => {
      mappings[item.sampleLabId] = sampleModals[item.sampleLabId]
        ? sampleModals[item.sampleLabId]
        : false;
    });
    setSampleModals(mappings);
    setShouldSave(false);
    setSubmissionModal(null);
    setCompareModals(model);
  }, [fields]);

  useEffect(() => {
    model.outTime = getFormattedDateTime();
    reset(model);
    setShouldSave(false);
    setSubmissionModal(null);
    setCompareModals(model);
  }, [model, reset]);

  const handleOpenAddSamplesDialog = (fields) => {
    setCurrentBatch(fields);
    setIsAddSamplesDialogOpen(true);
  };

  const handleCloseAddSamplesDialog = () => {
    setIsAddSamplesDialogOpen(false);
  };

  const handleSaveSamples = () => {
    onSuccess();
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedBatch(null);
  };

  const handleSaveBatch = (updatedBatch) => {
    onSuccess(updatedBatch);
  };
  const handleOpenDialog = (batch) => {
    setSelectedBatch(batch);
    setIsDialogOpen(true);
  };

  const handleFormSubmit = (data) => {
    if (data.analysisType === "HPC" || data.analysisType === "HPCDW") {
      const samples = data.samplesInBatch;

      for (const sample of samples) {
        if (!hpcBatchResults.includes(sample.hpc)) {
          setIsHpcResultInfoOpen(true);
          return;
        }
      }
    }

    if (shouldSave === true) {
      onsubmit(data);
    } else {
      if (data.outTime !== null && isValidCheckOutLower(data)) {
        setIsCheckoutTimeOpen(true);
        return;
      }
      setSubmissionModal(data);
      setBatchData(createBatchData(data));
      if (shouldShowConformationPopup(data) === true) {
        setIsCheckoutOpen(true);
      } else {
        setIsCheckoutOpen(false);
        onsubmit(data);
      }
    }
  };

  const getTotalHours = (date) => {
    const placedDate = new Date(date);
    const currentDate = new Date();

    const diffTime = Math.abs(currentDate - placedDate);
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

    return `${diffHours} Hrs- ${diffMinutes} Min`;
  };
  const handleDeleteConfirmationClose = () => {
    setIsDeleteConfirmationOpen(false);
  };

  const handleDeleteSampleConfirmationClose = () => {
    setIsDeleteSampleConfirmationOpen(false);
  };

  const handleHpcResultInfoClose = () => {
    setIsHpcResultInfoOpen(false);
  };

  const handleCheckoutTimeClose = () => {
    setIsCheckoutTimeOpen(false);
  };
  const handleDeleteConfirmationConfirm = () => {
    setIsDeleteConfirmationOpen(false);
    DeleteBatch(model.id);
    onSuccess(model);
    NotificationManager.success("Batch deleted", "Success!");
  };

  const handleDeleteSampleConfirmationConfirm = async () => {
    setIsDeleteSampleConfirmationOpen(false);

    const sampleToDelete = model.samplesInBatch.find(
      (sample) => sample.sampleLabId === deleteSampleLabelId
    );

    if (sampleToDelete) {
      try {
        await DeleteSample(sampleToDelete.id);
        onSuccess(model);
        NotificationManager.success("Sample deleted", "Success!");
      } catch (error) {
        NotificationManager.error("Failed to delete sample", error.message);
      }
    } else {
      NotificationManager.error("Sample not found", "Error!");
    }
  };

  const handleCheckoutClose = () => {
    setIsCheckoutOpen(false);
  };

  const handleCheckoutConfirm = () => {
    setIsCheckoutOpen(false);
    onsubmit(submissionModal);
  };
  const onBatchDelete = () => {
    setIsDeleteConfirmationOpen(true);
  };

  const isValidCheckOutLower = (data) => {
    if (!data.outTime) {
      return false; // No checkout time provided
    }

    const batchTypeBounds = {
      HPC: 45,
      HPCDW: 48,
      TCDW: 24,
      TCPOOL: 24,
      Ecoli: 24,
      // Add more batch types if needed
    };

    const lowerBound = batchTypeBounds[model.analysisType];

    const inTime = new Date(model.inTime);
    const outTime = new Date(data.outTime);
    const timeDifferenceInHours = (outTime - inTime) / (1000 * 60 * 60);

    // Check if the time difference is less than the lower bound
    return timeDifferenceInHours < lowerBound;
  };

  const onsubmit = async (data) => {
    props.callBack(data);
    SaveEditHistory(data);
    setCompareModals(null);
    try {
      if (shouldSave === true) {
        data.outTime = null;
        data.outUser = null;
      } else {        
        if (
          (outUser == undefined || outUser === "") &&
          (data.outUser == undefined || data.outUser === "")
        ) {
          NotificationManager.error("Select Out User");
          return;
        } else {
          data.outUser = outUser== "" ? data.outUser : outUser;
        }
      }

      await SubmitBatchResults(data);

      if (shouldSave === true) {
        NotificationManager.success("Batch saved", "Success!");
        setShouldSave(false);
        setSubmissionModal(null);
      } else {
        NotificationManager.success("Batch submitted", "Success!");
        setShouldSave(false);
        setSubmissionModal(null);
      }
      onSuccess(model);
    } catch (err) {
      NotificationManager.error(err.toString(), "Error Submitting");
    }
  };

  const SaveEditHistory = async (data) => {
    try {
      if (data.samplesInBatch && compareModals.samplesInBatch) {
        const changes = [];
        changes.push("+++At Micro Out: ");

        data.samplesInBatch.forEach((sample, index) => {
          const compareSample = compareModals.samplesInBatch[index];
          if (
            compareSample.coliform !== null &&
            sample.coliform !== compareSample.coliform
          ) {
            changes.push(
              `Sample ${sample.sampleLabId}: Coliform changed from "${compareSample.coliform}" to "${sample.coliform}"`
            );
          }
          if (
            compareSample.ecoli !== null &&
            sample.ecoli !== compareSample.ecoli
          ) {
            changes.push(
              `Sample ${sample.sampleLabId}: Ecoli changed from "${compareSample.ecoli}" to "${sample.ecoli}"`
            );
          }

          if (
            compareSample.hpc !== null &&
            compareSample.hpc !== "<2" &&
            sample.hpc !== compareSample.hpc
          ) {
            changes.push(
              `Sample ${sample.sampleLabId}: HPC changed from "${compareSample.hpc}" to "${sample.hpc}"`
            );
          }
          if (
            compareSample.imageBase64 !== null &&
            sample.imageBase64 !== compareSample.imageBase64
          ) {
            changes.push(`Sample ${sample.sampleLabId}: Image changed`);
          }
          if (
            compareSample.result !== null &&
            compareSample.result !== "<2" &&
            sample.result !== compareSample.result
          ) {
            changes.push(
              `Sample ${sample.sampleLabId}: Result changed from "${compareSample.result}" to "${sample.result}"`
            );
          }
        });

        if (changes.length > 1) {
          const loggedInUser = JSON.parse(
            localStorage.getItem("loggedInUser")
          ).operator;
          const timestamp = new Date().toLocaleString();
          const historyEntry =
            changes.join("___") + ` by ${loggedInUser} on ${timestamp}`;

          await SaveBatchEditHistory({
            batchId: data.id,
            batchEditHistory: historyEntry,
          });
        }
      }
    } catch (err) {
      NotificationManager.error(err.toString(), "Error Submitting");
    }
  };

  const createBatchData = (data) => {
    if (model.analysisType === "HPC") {
      return {
        timeSpan: "45-72",
        inTime: model.inTime,
        batchType: "HPC (Pool)",
        outTime: data.outTime,
      };
    }
    if (model.analysisType === "HPCDW") {
      return {
        timeSpan: "48-72",
        inTime: model.inTime,
        batchType: "HPC DW",
        outTime: data.outTime,
      };
    }
    if (model.analysisType === "TCDW") {
      return {
        timeSpan: "24-28",
        inTime: model.inTime,
        batchType: "TC (DW)",
        outTime: data.outTime,
      };
    }

    if (model.analysisType === "TCPOOL") {
      return {
        timeSpan: "24-28",
        inTime: model.inTime,
        batchType: "TC (Pool)",
        outTime: data.outTime,
      };
    }

    if (model.analysisType === "Ecoli") {
      return {
        timeSpan: "24-28",
        inTime: model.inTime,
        batchType: "Ecoli",
        outTime: data.outTime,
      };
    }
  };

  const shouldShowConformationPopup = (data) => {
    const inTime = new Date(model.inTime);
    const outTime = new Date(data.outTime);

    // Calculate the time difference in hours
    const timeDifferenceInHours = (outTime - inTime) / (1000 * 60 * 60);

    // Get the corresponding time span for the current analysisType
    const timeSpans = {
      HPC: 72,
      HPCDW: 72,
      TCDW: 28,
      TCPOOL: 28,
      Ecoli: 28,
    };

    // Get the time span for the current analysisType
    const timeSpan = timeSpans[model.analysisType];

    // Check if the time difference is greater than or equal to the time span in hours
    // Also check if the time difference is greater than the time span by 1 minute
    return (
      timeDifferenceInHours >= timeSpan ||
      timeDifferenceInHours >= timeSpan - 1 / 60
    );
  };

  const toggleModal = (labId) => {
    setSampleModals({ ...sampleModals, [labId]: !sampleModals[labId] });
  };

  /**
   *
   * @param {SampleInfo} field The BatchSample that is being rendered
   * @param {int} i The index of the BatchSample in the array
   * @returns
   */
  const renderResultsForBatchSample = (field, i) => {
    switch (model.analysisType) {
      case "HPC":
        return (
          <input
            type="text"
            className="input"
            placeholder="MPN"
            {...register(`samplesInBatch.${i}.hpc`)}
          />
        );
      case "HPCDW":
        return (
          <input
            type="text"
            className="input"
            placeholder="MPN"
            {...register(`samplesInBatch.${i}.hpc`)}
          />
        );
      case "TCDW":
        return (
          <div className="columns">
            <div className="column">
              <div className="columns">
                <div className="column has-text-right">
                  <label htmlFor="">Coliform</label>
                </div>
                <div className="column">
                  <input
                    type="checkbox"
                    defaultChecked={false}
                    style={{ height: "25px", width: "25px", margin: "0" }}
                    {...register(`samplesInBatch.${i}.coliform`)}
                  />
                </div>
              </div>
            </div>
            <div className="column">
              <div className="columns">
                <div className="column has-text-right">
                  <label htmlFor="">E.Coli</label>
                </div>
                <div className="column">
                  <input
                    type="checkbox"
                    defaultChecked={false}
                    style={{ height: "25px", width: "25px", margin: "0" }}
                    {...register(`samplesInBatch.${i}.ecoli`)}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case "TCPOOL":
        return (
          <div className="columns">
            <div className="column">
              <div className="columns">
                <div className="column has-text-right">
                  <label htmlFor="">Coliform</label>
                </div>
                <div className="column">
                  <input
                    type="checkbox"
                    defaultChecked={false}
                    style={{ height: "25px", width: "25px", margin: "0" }}
                    {...register(`samplesInBatch.${i}.coliform`)}
                  />
                </div>
              </div>
            </div>
            <div className="column">
              <div className="columns">
                <div className="column has-text-right">
                  <label htmlFor="">E.Coli</label>
                </div>
                <div className="column">
                  <input
                    type="checkbox"
                    defaultChecked={false}
                    style={{ height: "25px", width: "25px", margin: "0" }}
                    {...register(`samplesInBatch.${i}.ecoli`)}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case "Ecoli":
        return (
          <input
            type="text"
            className="input"
            placeholder="MPN"
            {...register(`samplesInBatch.${i}.result`)}
          />
        );
      default:
        return <></>;
    }
  };

  const renderModalForBatchSample = (field, i) => {
    return (
      <Modal
        closeModal={() => toggleModal(field.sampleLabId)}
        isOpen={sampleModals[field.sampleLabId]}
        title={field.sampleLabId}
      >
        <div className="columns">
          <div className="column">
            <textarea
              className="input"
              rows={10}
              style={{ minHeight: "100px" }}
              placeholder="Comments"
              {...register(`samplesInBatch.${i}.comments`)}
            ></textarea>
          </div>
        </div>
        <div className="column">
          <div className="column">
            <input
              type="text"
              hidden
              {...register(`samplesInBatch.${i}.imageBase64`)}
            />
            {getValues(`samplesInBatch.${i}.imageBase64`) ? (
              <>
                <img src={getValues(`samplesInBatch.${i}.imageBase64`)} />
                <div className="has-text-right">
                  <button
                    type="button"
                    onClick={() => {
                      let currObj = getValues(`samplesInBatch.${i}`);
                      currObj.imageBase64 = null;
                      update(i, currObj);
                    }}
                    className="button is-warning"
                  >
                    <FontAwesomeIcon icon={faImage} />
                    &nbsp; Retake
                  </button>
                </div>
              </>
            ) : (
              <Webcam
                audio={false}
                height={720}
                screenshotFormat="image/jpeg"
                width={1280}
                videoConstraints={{
                  width: 1280,
                  height: 720,
                  facingMode: "environment",
                }}
              >
                {({ getScreenshot }) => (
                  <div className="has-text-right">
                    <button
                      onClick={() => {
                        const imageSrc = getScreenshot();
                        let currObj = getValues(`samplesInBatch.${i}`);
                        currObj.imageBase64 = imageSrc;
                        update(i, currObj);
                      }}
                      type="button"
                      className="button is-primary is-right"
                    >
                      <FontAwesomeIcon icon={faCamera} />
                    </button>
                  </div>
                )}
              </Webcam>
            )}
          </div>
        </div>
      </Modal>
    );
  };

  if (!model.inTime) return <></>;

  return (
    <>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="columns ">
          <div className="column is-5">
            <span className="title is-4">
              {model.analysisType} - Batch {BatchName(model.inTime)}
            </span>
            <br />
            <span
              className="tag is-primary is-light"
              style={{ marginTop: "10px", fontSize: "16px" }}
            >
              <span style={{ fontWeight: "bold" }}>In Time:</span>{" "}
              {formatDateTime(model.inTime)} - (
              <span style={{ color: "red" }}>
                {getTotalHours(model.inTime)}
              </span>
              )
            </span>
          </div>
          <div className="column">
            <>
              
              <span
                className="tag is-info is-light"
                style={{ marginLeft: "10px" }}
              >
                In User: {model.inUser}
              </span>

              {loggedInUser.groups &&
                loggedInUser.groups.includes("admin") &&
                !isMobile && (
                  <IconButton
                    aria-label="edit"
                    style={{ color: "orange" }}
                    onClick={() => handleOpenDialog(model)}
                  >
                    <EditIcon />
                  </IconButton>
                )}

              <button
                className="button is-primary is-small"
                style={{ marginLeft: "10px", marginRight: "10px" }}
                role="submit"
                onClick={() => {
                  setShouldSave(true);
                }}
              >
                Save
              </button>

              <button
                className="button is-warning is-small"
                type="button"
                onClick={() => {
                  onBatchDelete();
                }}
              >
                Delete
              </button>
              <br />
            </>
          </div>
        </div>

        <div className="columns">
          <div className="column is-3">
            <label htmlFor="" className="label">
              Out Time
            </label>
            <input
              className="input"
              type="datetime-local"
              {...register("outTime")}
            />
          </div>

          {isFromVlp && users !== undefined && (
            <div className="column">
              <label htmlFor="outUser" className="label">
                {`Select Out User`}
              </label>
              <select
                id="inUser"
                className="input"
                value={outUser}
                onChange={(e) => setOutUser(e.target.value)}
                fullWidth
                margin="normal"
              >
                {users.map((user) => (
                  <option key={user} value={user.trim()}>
                    {user.trim()}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="column">
            <label className="label">{`Batch Comments`}</label>
            <input
              type="text"
              className="input"
              maxLength="200"
              placeholder="Batch Comments"
              {...register(`samplesInBatch.${0}.reviewComment`)}
            />
          </div>
        </div>
        <div className="columns">
          <div className="column">
            {loggedInUser.groups && loggedInUser.groups.includes("admin") && (
              <button
                type="button"
                className={"button is-info"}
                onClick={() => handleOpenAddSamplesDialog(fields)}
              >
                <FontAwesomeIcon icon={faPlusCircle} />
                &nbsp;New Sample
              </button>
            )}
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <p className="title is-6">Sample  ({fields?.length}) </p>
          </div>
          <div className="column">
            <p className="title is-6">Result</p>
          </div>
        </div>
        <hr />
        {fields
          .sort(function compare(a, b) {
            try {
              var aSections = a.sampleLabId.split("-");
              var bSections = b.sampleLabId.split("-");
              if (aSections.length > 1) {
                if (aSections[0] > bSections[0]) {
                  return 1;
                } else if (aSections[0] === bSections[0]) {
                  if (parseInt(aSections[1]) > parseInt(bSections[1])) return 1;
                  else return -1;
                } else {
                  return -1;
                }
              }
              if (a.sampleLabId > b.sampleLabId) return 1;
              return -1;
            } catch (err) {
              return 0;
            }
          })
          .map((item, i) => (
            <div key={item.id}>
              {renderModalForBatchSample(item, i)}
              <div className="columns">
                <div className="column">
                  <IconButton
                    aria-label="edit"
                    style={{ color: "red" }}
                    onClick={() => {
                      setDeleteSampleLabelId(item.sampleLabId);
                      setIsDeleteSampleConfirmationOpen(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>

                  <span>{item.sampleLabId}</span>
                </div>
                <div className="column">
                  {renderResultsForBatchSample(item, i)}
                </div>
                <div className="column is-2">
                  <button
                    type="button"
                    className={
                      "button " +
                      (getValues(`samplesInBatch.${i}.comments`) ||
                      getValues(`samplesInBatch.${i}.imageBase64`)
                        ? "is-link"
                        : "is-info")
                    }
                    onClick={() => toggleModal(item.sampleLabId)}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} />
                    &nbsp;More Info
                  </button>
                </div>
              </div>
            </div>
          ))}
        <div className="columns">
          <div className="column has-text-right">
            {model.color !== "Grey" && (
              <input
                type="submit"
                className="button is-primary"
                style={{ marginRight: "20px" }}
              />
            )}
          </div>
        </div>
      </form>

      <InformationPopup
        isOpen={isHpcResultInfoOpen}
        onClose={handleHpcResultInfoClose}
        title="Invalid HPC Results"
        message="Invalid HPC result value. Please enter valid result."
        color="red"
      />
      <InformationPopup
        isOpen={isCheckoutTimeOpen}
        onClose={handleCheckoutTimeClose}
        title="Invalid Check-Out Date/Time"
        message="Invalid check out time. Please wait for the minimum incubation time before pulling out the batch."
        color="red"
      />

      <ConfirmationPopup
        isOpen={isDeleteConfirmationOpen}
        onClose={handleDeleteConfirmationClose}
        onConfirm={handleDeleteConfirmationConfirm}
        title="Delete Confirmation"
        message="Are you sure you would like to delete this batch?"
        color="red"
      />

      <ConfirmationPopup
        isOpen={isDeleteSampleConfirmationOpen}
        onClose={handleDeleteSampleConfirmationClose}
        onConfirm={handleDeleteSampleConfirmationConfirm}
        title="Delete Confirmation"
        message="Are you sure you would like to delete this sample?"
        color="red"
      />
      <BatchCheckOutConfirmationPopup
        isOpen={isCheckoutOpen}
        onClose={handleCheckoutClose}
        onConfirm={handleCheckoutConfirm}
        title="Batch Check-Out Confirmation"
        message="Are you sure about the check-out time?"
        color="red"
        batchData={batchData}
      />

      <EditMicroOutBatchDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        batch={selectedBatch}
        onSave={handleSaveBatch}
      />

      {currentBatch && (
        <AddSamplesDialog
          open={isAddSamplesDialogOpen}
          onClose={handleCloseAddSamplesDialog}
          batch={currentBatch}
          onSave={handleSaveSamples}
          model={model}
        />
      )}
    </>
  );
}
